import { render, staticRenderFns } from "./HoldingOrderSummary.vue?vue&type=template&id=c7e4b4cc&scoped=true"
import script from "./HoldingOrderSummary.vue?vue&type=script&lang=js"
export * from "./HoldingOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./HoldingOrderSummary.vue?vue&type=style&index=0&id=c7e4b4cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e4b4cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e4b4cc')) {
      api.createRecord('c7e4b4cc', component.options)
    } else {
      api.reload('c7e4b4cc', component.options)
    }
    module.hot.accept("./HoldingOrderSummary.vue?vue&type=template&id=c7e4b4cc&scoped=true", function () {
      api.rerender('c7e4b4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/HoldingOrderSummary.vue"
export default component.exports